<template>
  <div class="clearfix register_form">
    <form-wizard v-if="validateForm1 == false" color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-dnger), 1)"
      :title="null" :subtitle="null" finishButtonText="Submit">
      <tab-content title="Step 1" class="mb-5" icon="feather icon-home" :before-change="validateStep1">
        <!-- tab 1 content -->
        <form data-vv-scope="step-1">
          <div class="vx-row">
            <div class="vx-col md:w-1/1 w-full mt-5">
              <vs-input label="First Name" v-model="firstName" class="w-full" name="first_name"
                v-validate="'required|alpha|min:5'" />
              <span class="text-danger">{{
                errors.first("step-1.first_name")
                }}</span>
            </div>
            <div class="vx-col md:w-1/1 w-full mt-5">
              <vs-input label="Last Name" v-model="lastName" class="w-full" name="last_name"
                v-validate="'required|min:5'" />
              <span class="text-danger">{{
                errors.first("step-1.last_name")
                }}</span>
            </div>
            <div class="vx-col md:w-1/1 w-full mt-5">
              <vs-input type="email" label="Email" v-model="email" class="w-full" name="email"
                v-validate="'required|email'" />
              <span class="text-danger">{{
                errors.first("step-1.email")
                }}</span>
            </div>
          </div>
        </form>
      </tab-content>

      <!-- tab 2 content -->
      <tab-content title="Step 2" class="mb-5" icon="feather icon-briefcase" :before-change="validateStep2">
        <form data-vv-scope="step-2">
          <div class="vx-row">
            <div class="vx-col md:w-1/1 w-full">
              <vs-input label="Company Name *" v-model="CompanyName" class="w-full mt-4" name="company_name"
                v-validate="'required'" />
              <span class="text-danger">{{
                errors.first("step-2.company_name")
                }}</span>

              <vs-input label="USDOT *" v-model="UsDot" class="w-full mt-4" type="text" name="usdot"
                v-validate="'required'" />
              <span class="text-danger">{{
                errors.first("step-2.usdot")
                }}</span>
            </div>
          </div>
          <div class="vx-col md:w-1/1 w-full mt-5">
            <vs-select v-model="Time" class="w-full select-large" label="Time Zone *" name="time"
              v-validate="'required'">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in timeOptions"
                class="w-full" />
            </vs-select>
            <span class="text-danger">{{ errors.first("step-2.time") }}</span>
          </div>
        </form>
      </tab-content>

      <!-- tab 3 content -->
      <tab-content title="Step 3" class="mb-5" icon="feather icon-settings" :before-change="validateStep3">
        <form data-vv-scope="step-3">
          <div class="vx-row">
            <div class="vx-col md:w-1/1 w-full mt-5">
              <vs-input label="Phone number" v-model="Phone" class="w-full mt-4" type="tel" name="telefon"
                v-validate="'required'" />
              <span class="text-danger">{{
                errors.first("step-3.telefon")
                }}</span>
            </div>
            <div class="vx-col md:w-1/1 w-full">
              <vs-input ref="password" type="password" data-vv-validate-on="blur" v-validate="'required|min:6'"
                name="password" label="Password" v-model="password" class="w-full mt-6" />
              <span class="text-danger text-sm">{{
                errors.first("step-3.password")
                }}</span>
            </div>
            <div class="vx-col md:w-1/1 w-full">
              <vs-input type="password" v-validate="'required|min:6|max:10|confirmed:password'"
                data-vv-validate-on="blur" data-vv-as="password" name="confirm_password" label="Confirm Password"
                v-model="confirm_password" class="w-full mt-6" />
              <span class="text-danger text-sm">{{
                errors.first("step-3.confirm_password")
                }}</span>
            </div>
            <div class="vx-col md:w-1/1 w-full md:mt-2">
              <vs-checkbox v-model="isTermsConditionAccepted" class="mt-6">I accept the terms &
                conditions.</vs-checkbox>
            </div>
          </div>
        </form>
      </tab-content>
    </form-wizard>
    <div v-if="validateForm1 === true" class="p-8">
      <div class="vx-card__title" style="margin: 10px 0px 50px 0px">
        <h4 class="mb-6" style="font-size: 33px">Verify your email</h4>
        <p style="font-size: 17px">
          We send verification code, please write verification code
        </p>
      </div>
      <vs-input type="number" name="number" label-placeholder="Verification code" v-model="activation_code"
        class="w-full mb-8" v-validate="'required|min:6|max:6'" />
      <span class="text-danger text-sm">{{ errors.first("number") }}</span>
      <vs-button type="border" @click="validateForm1 = false"
        class="float-left px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0" style="margin-bottom: 50px">Back</vs-button>
      <vs-button @click="registerUserJWT" class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0"
        style="margin-bottom: 50px">Submit</vs-button>
    </div>
    <vs-button type="border" to="/login" class="mt-6 mb-6 w-full">Login</vs-button>
  </div>
</template>
<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
export default {
  data() {
    return {
      show: false,
      firstName: "",
      activation_code: "",
      lastName: "",
      email: "",
      CompanyName: "",
      UsDot: "",
      Time: "",
      Phone: "",
      password: "",
      validateForm: false,
      validateForm1: false,
      confirm_password: "",
      isTermsConditionAccepted: true,
      timeOptions: [
        { text: "Alaskan Standard Time", value: "alaska" },
        { text: "Central Standard Time", value: "central" },
        { text: "Eastern Standard Time", value: "eastern" },
        { text: "Hawaiian Standard Time", value: "hawaiian" },
        { text: "Mountain Daylight Time", value: "mountaind" },
        { text: "Mountain Standard Time", value: "mountains" },
        { text: "Pacific Standard Time", value: "pacific" },
      ],
    };
  },
  methods: {
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-1").then((result) => {
          if (result) {
            this.validateForm = false;
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep2() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-2").then((result) => {
          if (result) {
            this.validateForm = false;
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep3() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-3").then((result) => {
          if (result) {
            this.$vs.loading();
            const payload = {
              userDetails: {
                email: this.email,
                password: this.password,
              },
            };
            // console.log(payload);
            this.$store
              .dispatch("auth/emailJWT", payload)
              .then(() => {
                this.$vs.loading.close();
                this.validateForm1 = true;
              })
              .catch((error) => {
                this.$vs.loading.close();
                this.$vs.notify({
                  title: "Error",
                  text: error.data.cause,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                });
              });
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    registerUserJWT() {
      const payload = {
        activation_code: this.activation_code,
        first_name: this.firstName,
        last_name: this.lastName,
        company_name: this.CompanyName,
        usdot: this.UsDot,
        time_zone: this.Time,
        phone: this.Phone,
        email: this.email,
        password: this.password,
      };
      this.$store
        .dispatch("auth/registerUserJWT", payload)
        .then(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: "Succesfully registered",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
          });
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
  },
  components: {
    FormWizard,
    TabContent,
  },
};

</script>

<style>
@media (max-width: 405px) {
  .clearfix {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .clearfix button {
    width: -webkit-fill-available;
  }
}
</style>
